<template>
    <div class="child-bg-image">
        <div class="bg-image-section" />

        <div class="content-section">
            <div class="download-apps">
                <img src="../../assets/img/swift-checkin-ezybuild-logo.png" alt="" width="120px">

                <h3>Welcome to SwiftCheckin</h3>

                <p>Please download our app for a better experience</p>

                <div class="store-buttons">
                    <a href="https://apps.apple.com/us/app/swift-checkin-construction-app/id6755225256" target="_blank">
                        <img src="../../assets/img/appstore.png" alt="" style="margin-right: 10px;">
                    </a>

                    <a href="https://play.google.com/store/apps/details?id=com.swiftcheckin.app" target="_blank">
                        <img src="../../assets/img/playstore.png" alt="">
                    </a>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DownloadApp'
}
</script>

<style scoped>
.child-bg-image {
    width: 100%;
    height: 100vh;
}

.content-section {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.download-apps {
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 30px;
    background: #fff;
    max-width: 400px;
    width: 90%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.store-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
}

.store-buttons img {
    width: 120px;
    cursor: pointer;
}
</style>